import { BARE_METAL_NODES_FIELD_KEY_LIST } from '../../capabilities/bare-metal-nodes/fieldKeys';
import { BARE_METAL_PROVISIONING_FIELD_KEY_LIST } from '../../capabilities/bare-metal-provisioning/fieldKeys';
import { BASE_INFO_FIELD_KEY_LIST } from '../../capabilities/base-info/fieldKeys';
import { IMAGE_FIELD_KEY_LIST } from '../../capabilities/image/fieldKeys';
import { NETWORK_FIELD_KEYS } from '../../capabilities/network/fieldKeys';
import { POWER_POLICY_FIELD_KEY_LIST } from '../../capabilities/power-policy/fieldKeys';
import { SERVICE_FIELD_KEY_LIST } from '../../capabilities/service/fieldKeys';

/** 裸金属网络表单路径（与 bareMetalFromForm / NetworkBlock pathPrefix="" 一致） */
export const BARE_METAL_NETWORK_FIELD_KEYS = ['vpc.name', 'subnet.name', 'securitygroup.name', NETWORK_FIELD_KEYS.staticIpv4] as const;

export const BARE_METAL_FIELD_KEYS = [
  ...BASE_INFO_FIELD_KEY_LIST,
  ...BARE_METAL_NETWORK_FIELD_KEYS,
  ...BARE_METAL_PROVISIONING_FIELD_KEY_LIST,
  ...IMAGE_FIELD_KEY_LIST,
  ...POWER_POLICY_FIELD_KEY_LIST,
  ...BARE_METAL_NODES_FIELD_KEY_LIST,
  ...SERVICE_FIELD_KEY_LIST,
] as const;

export type BareMetalFieldKey = (typeof BARE_METAL_FIELD_KEYS)[number];
